export { default } from '@/components/pages/Landing';
